import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["child"]
  static values = {
    childUrl: String,
    allowPrompt: { type: Boolean, default: true },
    selectPromptText: { type: String, default: "Select" },
    loadingText: { type: String, default: "Loading models..." }
  }

  connect() {
    const select = this.childTarget
    this.originalPrompt = select.querySelector('option[value=""]')?.textContent || this.selectPromptTextValue

    const existingOptions = Array.from(select.options).filter(option => option.value !== "")

    if (existingOptions.length > 0) {
      select.disabled = false
      if (select.tomselect) {
        select.tomselect.enable()
      }
    } else {
      this.updateChildOptions([])
    }
  }

  updateChild(event) {
    const selectedValue = event.target.value

    if (selectedValue && selectedValue !== "") {
      this.updateChildOptions([], true)
      this.fetchChildOptions(selectedValue)
    } else {
      this.updateChildOptions([])
    }
  }

  async fetchChildOptions(parentId) {
    try {
      const response = await fetch(this.childUrlValue.replace(':id', parentId), {
        headers: { 'Accept': 'application/json' }
      })
      if (response.ok) {
        this.updateChildOptions(await response.json())
      } else {
        this.updateChildOptions([])
      }
    } catch (error) {
      console.error('Error fetching child options:', error)
      this.updateChildOptions([])
    }
  }

  updateChildOptions(options, isLoading = false) {
    const select = this.childTarget
    const hasOptions = options.length > 0
    const promptText = isLoading ? this.loadingTextValue : this.originalPrompt

    const existingValues = Array.from(select.selectedOptions).map(option => option.value).filter(val => val !== "")

    select.innerHTML = this.allowPromptValue ? `<option value="">${promptText}</option>` : ""
    options.forEach(opt => {
      const option = document.createElement('option')
      option.value = opt.id
      option.textContent = opt.name
      if (existingValues.includes(opt.id.toString())) {
        option.selected = true
      }
      select.appendChild(option)
    })

    select.disabled = !hasOptions

    if (select.tomselect) {
      select.tomselect.clear(true)
      select.tomselect.clearOptions()
      const tomSelectOptions = this.allowPromptValue ?
        [{ value: "", text: promptText }, ...options.map(opt => ({ value: opt.id, text: opt.name }))] :
        options.map(opt => ({ value: opt.id, text: opt.name }))
      select.tomselect.addOptions(tomSelectOptions)
      select.tomselect[hasOptions ? 'enable' : 'disable']()
      select.tomselect.refreshOptions()

      if (existingValues.length > 0) {
        select.tomselect.setValue(existingValues, true)
      } else {
        select.tomselect.setValue("", true)
      }
    }
  }
}
